module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/Users/gabrielcireap/Projects/competdac-web/src/locales","languages":["ro"],"defaultLanguage":"ro","redirect":false},
    }]
